import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import vessiTheme from '@/themes/vessi-theme';

Vue.use(Vuetify);

export default new Vuetify({
	theme: vessiTheme,
	icons: {
		iconfont: 'md',
	},
});
